import React, { useState, useRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import images from '../../../assets/images/constantImages';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const OtpCanteen = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const canteenId = localStorage.getItem("canteenId");
    const navigate = useNavigate();
    const inputRefs = useRef([]);
    const validationSchema = Yup.object({
        digit1: Yup.string().matches(/^\d$/, "Required").required("Required"),
        digit2: Yup.string().matches(/^\d$/, "Required").required("Required"),
        digit3: Yup.string().matches(/^\d$/, "Required").required("Required"),
        digit4: Yup.string().matches(/^\d$/, "Required").required("Required"),
    });

    const handleSubmit = async (values) => {
        const enteredOtp = values.digit1 + values.digit2 + values.digit3 + values.digit4;
        setIsSubmitting(true);
        try {
            const response = await axios.post(
                `https://headquater.pixoatic.com/api/v1/customer_users/verify_otp?id=${canteenId}&otp=${enteredOtp}`, {
                headers: { "Content-Type": "application/json" },
            }
            );
            console.log("response", response);

            toast.success("OTP Verified Successfully");
            localStorage.setItem("canteenToken", response.data.token);
            localStorage.setItem("canteenUserName", response.data.name);
            navigate("/cartOrders")
        } catch (errors) {
            toast.error(errors?.response?.data?.errors);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleInputChange = (e, index, setFieldValue) => {
        const value = e.target.value;
        if (/^\d?$/.test(value)) {
            setFieldValue(`digit${index + 1}`, value);
            if (value && index < 3) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    return (
        <div className="w-full flex relative justify-center items-center">
            <div className="absolute top-0 z-10 w-full">
                <img
                    src={images.loginclipimage}
                    alt="background"
                    className="w-full h-screen opacity-[8%]"
                />
            </div>
            <div className="md:w-[50%] md:bg-white flex justify-center items-center md:relative absolute inset-0 z-20 rounded-md">
                <div className="bg-white w-[310px] py-3 px-5 xs:w-[430px] md:w-[400px] lp:w-[450px] flex flex-col">
                    <h1 className="text-G800 font-bold text-2xl xs:text-[30px] text-center mb-2">
                        OTP
                    </h1>
                    <p className="text-center text-G200 font-normal text-sm xs:text-[16px] leading-[24px] mb-4 md:mb-5">
                        Lorem Ipsum is simply dummy text of the printing
                        and typesetting industry.
                    </p>

                    <Formik
                        initialValues={{ digit1: "", digit2: "", digit3: "", digit4: "" }}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ setFieldValue, isSubmitting }) => (
                            <Form>
                                <div className="mb-4">
                                    <label className="block text-sm text-G200 mb-2">Enter OTP</label>
                                    <div className="flex gap-3 mb-10">
                                        {[0, 1, 2, 3].map((index) => (
                                            <Field
                                                key={index}
                                                name={`digit${index + 1}`}
                                                innerRef={el => inputRefs.current[index] = el}
                                                maxLength="1"
                                                className="w-12 h-12 text-center border border-G30 rounded-md text-xl outline-none"
                                                onChange={(e) =>
                                                    handleInputChange(e, index, setFieldValue)
                                                }
                                            />
                                        ))}
                                    </div>
                                    <div className="text-sm text-red">
                                        <ErrorMessage name="digit1" component="span" />
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    disabled={isSubmitting || isSubmitting}
                                    className={`w-full py-2 px-4 bg-canteengreen text-white rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                                        }`}
                                >
                                    {isSubmitting ? "Verifying..." : "Submit"}
                                </button>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
            <div className="md:w-[50%] ">
                <img src={images.platesimages} alt="platesimages" loading='lazy' className='w-full h-screen' />
            </div>
        </div>
    );
};

export default OtpCanteen;
